<template>
  <div 
    class="mt-5">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                {{ form.id === '' ? 'Tambah' : 'Ubah' }}
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>

                  <v-row>
                    <v-col cols="12" class="pt-0">
                      <ValidationProvider
                        name="Tanggal" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Tanggal
                        </div>

                        <v-text-field
                          v-on:keyup.enter="save()"
                          
                          outlined
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Contoh. 2021-01-01"

                          hide-details
                          type="date"

                          v-model="form.date"
                          :error-messages="errors"
                          required
                          class="mb-6"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="form.date !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                  <!-- <v-row>
                    <v-col cols="12" md="6">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Tanggal Mulai
                      </div>
    
                      <v-menu
                        v-model="date.start"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        >
                        <template v-slot:activator="{ on, attrs }">
                          <ValidationProvider
                            name="Tanggal Mulai" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <v-text-field
                              v-model="form.date"
                              placeholder="Pilih Tanggal Mulai"
                              hide-details
                              :color="set_color"
                              readonly
                              filled
                              rounded
                              dense
                              required
                              v-bind="attrs"
                              v-on="on"
                              :success="form.date !== '' && valid"
                              :error-messages="errors"
                              class="mb-6"
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
    
                                <div v-if="form.date !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                        </ValidationProvider>
                        </template>
                        <v-date-picker
                          v-model="form.date"
                          :color="set_color"
                          @input="form.start_time = ''; form.end_date = ''; form.end_time = ''; date.start = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Waktu Mulai
                      </div>
    
                      <v-menu
                        ref="start"
                        v-model="time.start"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="form.start_time"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                        >
                        <template v-slot:activator="{ on, attrs }">
                          <ValidationProvider
                            name="Waktu Mulai" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <v-text-field
                              v-model="form.start_time"
                              placeholder="Pilih Waktu Mulai"
                              hide-details
                              :color="set_color"
                              readonly
                              filled
                              rounded
                              dense
                              required
                              v-bind="form.date === '' ? '' : attrs"
                              v-on="form.date === '' ? '' : on"
                              :success="form.start_time !== '' && valid"
                              :error-messages="errors"
                              class="mb-6"
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
    
                                <div v-if="form.start_time !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                        </ValidationProvider>
                        </template>
                        <v-time-picker
                          v-model="form.start_time"
                          full-width
                          format="24hr"
                          :color="set_color"
                          v-if="time.start"
                          @click:minute="$refs.start.save(form.start_time)"
                          @input="form.end_date = ''; form.end_time = '';"
                        ></v-time-picker>
                      </v-menu>
                    </v-col>

                    <v-col cols="12" md="6">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Tanggal Selesai
                      </div>
    
                      <v-menu
                        v-model="date.end"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        >
                        <template v-slot:activator="{ on, attrs }">
                          <ValidationProvider
                            name="Tanggal Selesai" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <v-text-field
                              v-model="form.end_date"
                              placeholder="Pilih Tanggal Selesai"
                              hide-details
                              :color="set_color"
                              readonly
                              filled
                              rounded
                              dense
                              required
                              v-bind="form.start_time === '' ? '' : attrs"
                              v-on="form.start_time === '' ? '' : on"
                              :success="form.end_date !== '' && valid"
                              :error-messages="errors"
                              class="mb-6"
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
    
                                <div v-if="form.end_date !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                        </ValidationProvider>
                        </template>
                        <v-date-picker
                          v-model="form.end_date"
                          :color="set_color"
                          :min="form.date"
                          @input="form.end_time = ''; date.end = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Waktu Selesai
                      </div>
    
                      <v-menu
                        ref="end"
                        v-model="time.end"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="form.end_time"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                        >
                        <template v-slot:activator="{ on, attrs }">
                          <ValidationProvider
                            name="Waktu Selesai" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <v-text-field
                              v-model="form.end_time"
                              placeholder="Pilih Waktu Selesai"
                              hide-details
                              :color="set_color"
                              readonly
                              v-bind="form.end_date === '' ? '' : attrs"
                              v-on="form.end_date === '' ? '' : on"
                              filled
                              rounded
                              dense
                              required
                              :success="form.end_time !== '' && valid"
                              :error-messages="errors"
                              class="mb-6"
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
    
                                <div v-if="form.end_time !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                        </ValidationProvider>
                        </template>
                        <v-time-picker
                          v-model="form.end_time"
                          full-width
                          format="24hr"
                          :color="set_color"
                          v-if="time.end"
                          :min="form.end_date === form.date ? form.start_time : ''"
                          @click:minute="$refs.end.save(form.end_time)"
                        ></v-time-picker>
                      </v-menu>
                    </v-col>
                  </v-row> -->
                  <ValidationProvider
                    name="Deskripsi" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Deskripsi
                    </div>
                    <v-textarea
                      v-on:keyup.enter="save()"
                      
                      outlined
                      rounded
                      dense
                      rows="3"

                      :color="set_color"
                      placeholder="Contoh. Tuliskan deskripsi disini . . ."

                      hide-details

                      v-model="form.description"
                      class="mb-2"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.description !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-textarea>
                  </ValidationProvider>

                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
        <section>
          <v-row
            class="pa-4 pb-0 pt-0">
            <v-col
              cols="12" class="pb-1">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="22">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="fs-16 black--text ml-2"
                      style="font-weight: 600;">
                      Hari Libur
                    </span>
                  </div>

                  <v-spacer />

                  <div>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="start"
            class="pa-4 py-0 pr-1">
            <v-col
              cols="12"
              md="12"
              class="d-flex align-center pb-1">
              <v-text-field
                @click:clear="search = ''; fetch();"
                v-on:keyup.enter="fetch()"

                filled
                rounded
                dense
                single-line

                hide-details
                :color="set_color"
                placeholder="Cari data yang Anda butuhkan . . ."
                append-icon="mdi-magnify"
                clearable

                v-model="search"
                class="fs-12 little-placeholder"
                style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 320px">
              </v-text-field>
              <v-btn
                color="#4B4B4B"
                elevation="0"
                small
                @click="dialog.form = true; reset();"
                min-height="30"
                class="fs-12 white--text text-capitalize d-flex align-center ml-3"
                style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon size="15">mdi-plus-circle-multiple</v-icon>
                
                <span
                  class="ml-2">
                  Tambah
                </span>
              </v-btn>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 py-0">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <div class="view">
                  <div v-if="!process.load" :class="process.load || list.length === 0 ? '' : 'wrapper-pegawai'">
                    <table style="border-radius: 10px; width: 100%;" class="table">
                      <tr>
                        <th :style="`background-color: ${set_color}; color: #fff;`" class="sticky-col one-col" style="z-index: 1;  color: white; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">Aksi</th>
                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'date' ? toSort('date') : toDesc();" style=" width: 1px;  white-space: nowrap; color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; width: 1px;  white-space: nowrap;">
                          Tanggal
                          <span v-if="sortBy === 'date'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                        <th :style="`background-color: ${set_color}; color: #fff;`" @click="sortBy !== 'description' ? toSort('description') : toDesc();" style=" color: white; font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                          Deskripsi
                          <span v-if="sortBy === 'description'">
                            <v-icon color="white" v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                            <v-icon color="white" v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                          </span>
                        </th>
                        
                      </tr>
                      <tr v-for="(item, index) in list" :key="index" @click="selected.row = index" :class="selected.row === index ? 'selected' : ''">
                        <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 120px; min-width: 120px; max-width: 120px; padding: 8px 2px; text-align: center;">
                          <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                
                                v-bind="attrs"
                                v-on="on"

                                min-width="25"
                                height="25"
                                x-small
                                @click="dialog.form = true; reset(index);"
                                rounded
                                color="blue"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="14">mdi-square-edit-outline</v-icon>
                              </v-btn>
                            </template>

                            <span>Ubah</span>
                          </v-tooltip>

                          <v-tooltip 
                            top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                @click="toDelete(item.id)"

                                v-bind="attrs"
                                v-on="on"

                                min-width="25"
                                height="25"
                                x-small
                                rounded
                                color="red"
                                elevation="0"
                                class="white--text text-capitalize mx-1 px-0"
                                style="font-weight: 600; border-radius: 6px;">
                                <v-icon size="14">mdi-trash-can-outline</v-icon>
                              </v-btn>
                            </template>
                            
                            <span>Hapus</span>
                          </v-tooltip>
                        </td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 1px;  white-space: nowrap; padding: 8px 12px; text-align: left;">{{ item.date | date }}</td>
                        <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 100%; padding: 8px 12px; text-align: left;">{{ item.description }}</td>
                        
                      </tr>
                    </table>
                  </div>
    
                  <v-card-text
                    v-if="process.load" 
                    class="pb-0 my-4" 
                    style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-4 title">
                        Mohon Tunggu . . .
                      </div>
    
                      <v-progress-linear
                        :color="set_color"
                        indeterminate
                        rounded
                        height="10">
                      </v-progress-linear>
                    </div>
                  </v-card-text>
    
                  <v-card-text
                    v-if="!process.load && list.length === 0"
                    class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <v-img 
                        class="mx-auto"
                        contain
                        alt="vuetify"
                        :width="90"
                        :height="90"
                        :src="require('@/assets/image/empty.png')">
                      </v-img>
                      <div class="mt-3 fs-16">
                        Belum Ada Data
                      </div>
                    </div>
                  </v-card-text>
    
                  <pagination v-if="!process.load && pagination.total_data > 0"
                    @changePage="fetch($event)" 
                    @reloadPage="fetch($event)" 
                    :model="pagination" :display="paginationList"/>
    
                </div>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          delete: false,
          reset: false,
          role: false,

          filter: false,
          form: false
        },
        
        search: '',

        filter: {
          
        },

        upload: {
          folder: null
        },
        

        selected: {
          row: [],
          freeze: [],
          delete: [],
          reset: [],
          role: []
        },

        paginationList: {
          row: 20,
          page: 1
        },

        role: [],
        sortBy: 'id',
        sortDesc: '-',

        options: {},
        headers: [],
        list: [],
        pagination: {},

        lastIndex: 0,
        limit: 20,

        form: {
          id: '',
          date: '',
          description: ''
        },

        process: {
          load: false,

          delete: false,
          reset: false,
          role: false,
          export: false,
          form: false,
          file: false,
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue'),
    },
    watch: {
      // 'options': {
      //   handler () {
      //     let pagination = { row: this.limit, page: 1 }
          
      //     this.fetch(pagination)
      //   },
      //   deep: true
      // }

      'upload.folder': {
        handler: function () {
          if (this.upload.folder) {
            this.process.file = this.upload.folder.process

            if (!this.process.file) {
              // CALLBACK FROM UPLOAD IMAGE
              
              // this.form.image_url = this.upload.folder.data.full.file_url
              this.form.image_url = this.upload.folder.fullpath
            }
          }
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
    },
    mounted () {
      this.fetch()
    },
    methods: {
      toSort(name) {
        this.sortBy = name
        this.sortDesc = ''
        this.fetch()
      },
      toDesc() {
        this.sortDesc === '-' ? this.sortDesc = '' : this.sortDesc = '-'
        this.fetch()
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row
        this.paginationList = pagination

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: `${this.sortDesc}${this.sortBy}`,
          // sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          'date[lse]': this.search
        }

        this.selected.row = []

        await get(`admin/holiday/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          this.list = []
          this.pagination = {}
            
          if (res.status === 200) {
            this.headers = [
              {
                text: 'Aksi',
                width: '150px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'center',
                format: 'action'
              },
              // {
              //   text: 'Status',
              //   width: '100px',
              //   value: 'is_active',
              //   freeze: false,
              //   hide: false,
              //   align: 'center',
              //   format: 'bool'
              // },
              // {
              //   text: 'Nomor Induk Pegawai',
              //   width: '200px',
              //   value: 'nip',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Nama Lengkap',
                width: '300px',
                value: 'name',
                freeze: false,
                hide: false
              },
              {
                text: 'Kategori Pegawai',
                width: '200px',
                value: 'cat_title',
                freeze: false,
                hide: false
              },
              {
                text: 'Email',
                width: '200px',
                value: 'email',
                freeze: false,
                hide: false
              },
              {
                text: 'Telepon',
                width: '200px',
                value: 'mobilephone',
                freeze: false,
                hide: false
              },
              // {
              //   text: 'Jenis Kelamin',
              //   width: '200px',
              //   value: 'gender',
              //   freeze: false,
              //   hide: false
              // },
              // {
              //   text: 'Nama Outlet',
              //   width: '400px',
              //   value: 'outlet_name',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Dibuat Tanggal',
                width: '100%',
                value: 'input_datetime',
                freeze: false,
                hide: false,
                format: 'datetime'
              }
            ]

            this.list = res.results.data
            this.pagination = res.results.pagination

            this.list.map(obj => {
              obj.is_active = obj.is_active === '1' ? true : false
            })

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: index !== undefined ? this.list[index].id : '',
          date: index !== undefined ? this.list[index].date : '',
          description: index !== undefined ? this.list[index].description : ''
        }

        this.process.form = false

        this.message.error = ''

        // if (this.dialog.form) 
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true
          // if (this.form.id === '') {
          //   this.list.push(
          //     {
          //       id: this.list.length,
          //       title: this.form.title,
          //       date: this.form.date,
          //       end_date: this.form.end_date,
          //       start_time: this.form.start_time,
          //       end_time: this.form.end_time,
          //       desc: this.form.desc,
          //       image_url: this.form.image_url
          //     }
          //   )
          // } else {
          //   this.list[this.form.id] = {
          //     id: this.form.id,
          //     title: this.form.title,
          //     date: this.form.date,
          //     end_date: this.form.end_date,
          //     start_time: this.form.start_time,
          //     end_time: this.form.end_time,
          //     desc: this.form.desc,
          //     image_url: this.form.image_url
          //   }
          // }
          // this.dialog.form = false

          // this.dialog.snackbar = true
          // this.message.success = this.form.id === '' ? 'Berhasil Menambah Agenda' : 'Berhasil Mengubah Agenda'

          // this.dialog.fullscreen = false

          // this.reset()

          // this.fetch()

          let url = this.form.id === '' ? 'admin/holiday/add' : 'admin/holiday/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.reset()

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/holiday/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      },
    }
  }
</script>

<style>
  /* ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #F5F5F5;
  }
  ::-webkit-scrollbar-track{
    background-color: #F5F5F5;
    border-radius: 10px;
  } */
  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #718EBF;
  }
  table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.view {
  margin: auto;
  /* width: 100%; */
}

.wrapper-pegawai { 
  overflow-y: auto; 
  height: calc(100vh - 265px); 
} 

.wrapper-pegawai-none { 
  /* overflow-y: auto; 
  height: calc(100vh - 270px);  */
} 

.wrapper-pegawai th { 
  position: sticky; 
  top: 0; 
  /* background-color: #080679 !important; */
} 
.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  /* background-color: #080679 !important; */
}

.one-col {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
  left: 0px;
}

.second-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 150px;
}

.three-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 300px;
}

.four-col {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  left: 450px;
}

tr:hover {background-color: #1976d236;}
tr.selected {background-color: #1976d236;}
</style>